"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var React = __importStar(require("react"));
var Item_1 = require("./Item");
require("./accordion.css");
var Accordion = function (_a) {
    var currentOpen = _a.currentOpen, items = _a.items, onClick = _a.onClick, _b = _a.arrow, arrow = _b === void 0 ? 'default' : _b, _c = _a.bottomBorder, bottomBorder = _c === void 0 ? false : _c, _d = _a.theme, theme = _d === void 0 ? 'default' : _d;
    var _e = React.useState({ currentOpen: currentOpen }), state = _e[0], setState = _e[1];
    var onClickCB = function (slug) { return function () {
        setState({ currentOpen: slug === state.currentOpen ? undefined : slug });
        return onClick && onClick(slug);
    }; };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "accordion" }, { children: items.map(function (item, index) { return ((0, jsx_runtime_1.jsx)(Item_1.Item, __assign({}, item, { arrow: arrow, bottomBorder: bottomBorder, open: state.currentOpen === item.slug, onClick: onClickCB(item.slug), theme: theme }), "".concat(item.slug, "-").concat(index))); }) })));
};
exports.Accordion = Accordion;
//# sourceMappingURL=Accordion.js.map